import { IFacetSelections } from '../types/facets'

export function isFacetOptionSelected(
  facetSelections: IFacetSelections,
  facetId: string,
  optionId: string
): boolean {
  const facet = facetSelections.find(f => f.id === facetId)
  if (!facet) {
    return false
  }
  return facet.selections.find(o => o === optionId) !== undefined
}
